import { render, staticRenderFns } from "./VMenuItem.vue?vue&type=template&id=4cf2557c"
import script from "./VMenuItem.vue?vue&type=script&lang=ts"
export * from "./VMenuItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports